<section class="services" id="services">
  <div class="services__content">
    <h2>{{ 'SERVICES.TITLE' | translate }}</h2>
    <ul class="services__list">
      <li *ngFor="let item of [0,1,2,3,4]">
        <h3>{{ ('SERVICES.LIST.' + item + '.TITLE') | translate }}</h3>
        <p [innerHTML]="('SERVICES.LIST.' + item + '.TEXT') | translate"></p>
      </li>
    </ul>
  </div>
</section>
